module.exports = __webpack_public_path__ + "img/wellnessmetric_no_title.3c094e71.svg";